<template>
  <div
    v-if="isVisible"
    class="modal-overlay"
    style="display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 1050;"
    @click.self="$emit('close')"
  >
    <div
      style="display: flex; flex-direction: column; width: 460px; max-width: 95vw; background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.2);"
    >
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center; padding: 18px 22px; border-bottom: 1px solid #F3F4F6;">
        <h2 style="font-size: 15px; font-weight: 600; color: #111827; margin: 0;">Actualizar plan de suscripción</h2>
        <button
          type="button"
          @click="$emit('close')"
          style="background: none; border: none; cursor: pointer; padding: 4px; line-height: 0;"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M11.1879 10.0096L15.5988 5.59876C15.6783 5.52188 15.7418 5.42993 15.7855 5.32826C15.8292 5.22659 15.8522 5.11724 15.8531 5.00659C15.8541 4.89594 15.833 4.78621 15.7911 4.68379C15.7492 4.58138 15.6873 4.48834 15.6091 4.41009C15.5308 4.33185 15.4378 4.26997 15.3354 4.22807C15.233 4.18617 15.1232 4.16509 15.0126 4.16605C14.9019 4.16701 14.7926 4.19 14.6909 4.23367C14.5892 4.27735 14.4973 4.34083 14.4204 4.42042L10.0096 8.83126L5.59876 4.42042C5.44159 4.26862 5.23109 4.18463 5.01259 4.18653C4.79409 4.18843 4.58508 4.27607 4.43057 4.43057C4.27607 4.58508 4.18843 4.79409 4.18653 5.01259C4.18463 5.23109 4.26862 5.44159 4.42042 5.59876L8.83126 10.0096L4.42042 14.4204C4.34083 14.4973 4.27735 14.5892 4.23367 14.6909C4.19 14.7926 4.16701 14.9019 4.16605 15.0126C4.16509 15.1232 4.18617 15.233 4.22807 15.3354C4.26997 15.4378 4.33185 15.5308 4.41009 15.6091C4.48834 15.6873 4.58138 15.7492 4.68379 15.7911C4.78621 15.833 4.89594 15.8541 5.00659 15.8531C5.11724 15.8522 5.22659 15.8292 5.32826 15.7855C5.42993 15.7418 5.52188 15.6783 5.59876 15.5988L10.0096 11.1879L14.4204 15.5988C14.5776 15.7506 14.7881 15.8345 15.0066 15.8327C15.2251 15.8308 15.4341 15.7431 15.5886 15.5886C15.7431 15.4341 15.8308 15.2251 15.8327 15.0066C15.8346 14.7881 15.7506 14.5776 15.5988 14.4204L11.1879 10.0096Z" fill="#9CA3AF"/>
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div style="padding: 22px;">

        <!-- Info plan actual -->
        <div style="background: #FFF7F8; border: 1px solid #FFD8DF; border-radius: 8px; padding: 12px 14px; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center; gap: 12px;">
          <div>
            <p style="font-size: 11px; color: #9CA3AF; margin: 0 0 2px 0; font-weight: 500; text-transform: uppercase; letter-spacing: 0.05em;">Plan actual</p>
            <p style="font-size: 14px; font-weight: 600; color: #111827; margin: 0 0 2px 0;">{{ payment?.plan_name || '—' }}</p>
            <p style="font-size: 12px; color: #6B7280; margin: 0;">{{ formatPrice(payment?.amount) }}</p>
          </div>
          <span
            v-if="!payment?.stripe_subscription_id"
            style="flex-shrink: 0; background: #FEF3C7; color: #92400E; font-size: 11px; padding: 3px 8px; border-radius: 4px; font-weight: 500; white-space: nowrap;"
          >Solo local</span>
          <span
            v-else
            style="flex-shrink: 0; background: #ECFDF5; color: #065F46; font-size: 11px; padding: 3px 8px; border-radius: 4px; font-weight: 500; white-space: nowrap;"
          >Stripe activo</span>
        </div>

        <!-- Select nuevo plan -->
        <div style="margin-bottom: 16px;">
          <label style="display: block; font-size: 13px; font-weight: 500; color: #374151; margin-bottom: 6px;">
            Nuevo plan
          </label>

          <div style="position: relative;">
            <select
              v-model="selectedPlanId"
              :disabled="availablePlans.length === 0"
              style="
                width: 100%;
                padding: 10px 36px 10px 12px;
                border: 1px solid #E5E7EB;
                border-radius: 8px;
                font-size: 14px;
                color: #111827;
                background: #FAFAFA;
                appearance: none;
                -webkit-appearance: none;
                cursor: pointer;
                outline: none;
                transition: border-color 0.15s;
              "
              @focus="e => e.target.style.borderColor = '#FF4265'"
              @blur="e => e.target.style.borderColor = '#E5E7EB'"
            >
              <option value="" disabled>Selecciona un plan...</option>
              <option
                v-for="plan in availablePlans"
                :key="plan.id"
                :value="plan.id"
              >
                {{ plan.name }} — {{ formatPrice(plan.price) }}{{ (!plan.price_stripe_id && payment?.stripe_subscription_id) ? ' ⚠️ Sin Stripe ID' : '' }}
              </option>
            </select>

            <!-- Ícono flecha -->
            <svg
              style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            >
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </div>

          <!-- Preview del plan seleccionado -->
          <div
            v-if="selectedPlan"
            style="margin-top: 10px; padding: 10px 12px; background: #F9FAFB; border: 1px solid #E5E7EB; border-radius: 8px; display: flex; justify-content: space-between; align-items: center;"
          >
            <span style="font-size: 13px; color: #374151; font-weight: 500;">{{ selectedPlan.name }}</span>
            <span style="font-size: 13px; color: #FF4265; font-weight: 600;">{{ formatPrice(selectedPlan.price) }} / mes</span>
          </div>

          <p v-if="availablePlans.length === 0" style="font-size: 12px; color: #9CA3AF; margin: 8px 0 0 0;">
            No hay otros planes disponibles.
          </p>
        </div>

        <!-- Nota informativa -->
        <div style="display: flex; gap: 8px; align-items: flex-start; padding: 10px 12px; background: #F9FAFB; border-radius: 8px; border: 1px solid #F3F4F6;">
          <svg style="flex-shrink: 0; margin-top: 1px;" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <p v-if="payment?.stripe_subscription_id" style="font-size: 12px; color: #6B7280; margin: 0; line-height: 1.5;">
            El nuevo plan se aplicará en el <strong>siguiente ciclo de facturación</strong> en Stripe y se actualizará en el sistema local.
          </p>
          <p v-else style="font-size: 12px; color: #6B7280; margin: 0; line-height: 1.5;">
            Esta suscripción no tiene Stripe. El cambio se aplicará <strong>únicamente en el sistema local</strong>.
          </p>
        </div>

      </div>

      <!-- Footer -->
      <div style="display: flex; justify-content: flex-end; gap: 10px; padding: 14px 22px; border-top: 1px solid #F3F4F6;">
        <button
          @click="$emit('close')"
          style="padding: 8px 16px; border-radius: 8px; border: 1px solid #E5E7EB; background: #FFF; color: #374151; font-size: 14px; font-weight: 500; cursor: pointer;"
        >
          Cancelar
        </button>
        <button
          @click="handleConfirm"
          :disabled="!selectedPlanId || loading"
          :style="{
            padding: '8px 16px',
            borderRadius: '8px',
            border: 'none',
            background: !selectedPlanId || loading ? '#FCA5B4' : '#FF4265',
            color: '#FFF',
            fontSize: '14px',
            fontWeight: '500',
            cursor: !selectedPlanId || loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            transition: 'background 0.15s'
          }"
        >
          <svg
            v-if="loading"
            style="animation: spin 1s linear infinite;"
            xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
          </svg>
          {{ loading ? 'Actualizando...' : 'Confirmar cambio' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  isVisible: { type: Boolean, required: true },
  payment:   { type: Object,  default: null },
  plans:     { type: Array,   default: () => [] },
  loading:   { type: Boolean, default: false }
})

const emit = defineEmits(['close', 'confirm'])

const selectedPlanId = ref('')

// Excluir el plan actual de la lista
const availablePlans = computed(() => {
  if (!props.plans || !props.payment) return props.plans || []
  return props.plans.filter(p => p.id !== props.payment.plan_id_raw)
})

// Plan seleccionado completo (para el preview)
const selectedPlan = computed(() =>
  props.plans.find(p => p.id === selectedPlanId.value) || null
)

// Resetear al abrir
watch(() => props.isVisible, (val) => {
  if (val) selectedPlanId.value = ''
})

function formatPrice(value) {
  if (!value) return '$0.00'
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)
}

function handleConfirm() {
  if (!selectedPlanId.value) return
  emit('confirm', {
    plan_id:         selectedPlanId.value,
    price_stripe_id: selectedPlan.value?.price_stripe_id || null,
    plan_name:       selectedPlan.value?.name || ''
  })
}
</script>

<style scoped>
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>